export const locations = {
  "ARCH": {
    position: [1.26, 0.15, -2],
    rotation: [Math.PI / 2, 0, 0]
  },
  "FOUNDATION": {
    position: [1.258, -0.449, -2],
    rotation: [0, -Math.PI / 2, 0]
  },
  "FLAT_CONCRETE": [
    {
      position: [1.258, 0.002, -2.15],
      rotation: [0, 0, 0]
    },
    {
      position: [1.108, 0.002, -2],
      rotation: [0, -Math.PI / 2, 0]
    },
  ],
  "INSIDE-GROUND": {
    position: [1.364, 0.182, -2.048]
  },
  "TOMATO": {
    position: [1.26, 0.966, -2],
    rotation: [-Math.PI, 0.275, -Math.PI]
  },
  "VEGIE": {
    position: [1.26, 0.067, -2],
    rotation: [-Math.PI / 2, 0, 0]
  },
  "GROUND-SECURE": [
    {
      position: [1.26, 0.18, -2.043],
      rotation: [0, 0, 0]
    },
    {
      position: [-1.24, 0.18, 0.04],
      rotation: [Math.PI, 0, Math.PI]
    },
  ],
  "CLADDING-RAIL": {
    "RIGHT": {
      position: [-1.262, 0.207, -1.828],
      rotation: [Math.PI, 0, Math.PI]
    },
    "LEFT": {
      position: [1.285, 0.182, -1.827],
      rotation: [Math.PI, 0, 0]
    }
  },
  "SIDE-VENT": {
    "RIGHT": {
      position: [-1.29, 0.943, -1.988],
      rotation: [0, 0, Math.PI / 2]
    },
    "LEFT": {
      position: [1.311, 0.943, 1.988],
      rotation: [-Math.PI, 0, -Math.PI / 2]
    }
  },
  "GABLE-END": {
    position: [0.713, 0.151, -2.016]
  },
  "GABLE-END-BACK": {
    position: [-0.692, 0.151, 2.016],
    rotation: [Math.PI, 0, Math.PI]
  },
  "2500": {
    "OVERHEAD_IRRIGATION": {
      position: [0, 2.332, 1.899]
    },
    "END-NOCUT": {
      position: [-0.009, 0.936, 1.724]
    },
    "CROSS": {
      position: [0, 2.367, -2]
    },
    "RIDGE-BAR": {
      position: [0, 2.363, -1.984]
    },
    "STEEL-GABLE": {
      'BACK': {
        position: [0.6, 2.26, 2.002]
      }
    },
    "LONGITUDINAL": [
      {
        position: [-0.5, 2.213, -2]
      },
      {
        position: [0.5, 2.213, -2]
      },
    ],
    "SIDE-PURLIN": [
      {
        position: [-1.039, 1.844, -1.992],
        rotation: [0, 0, 0.971]
      },
      {
        position: [1.059, 1.844, 1.993],
        rotation: [-Math.PI, 0, -2.171]
      },
    ]
  },
  "3500": {
    "OVERHEAD_IRRIGATION": {
      position: [-0.5, 2.448, 1.899]
    },
    "END-NOCUT": {
      position: [-0.519, 1.325, 3.594]
    },
    "CROSS": {
      position: [-0.5, 2.483, -2]
    },
    "RIDGE-BAR": {
      position: [-0.5, 2.479, -1.984]
    },
    "STEEL-GABLE": {
      'BACK': {
        position: [0.1, 2.442, 2.002]
      }
    },
    "LONGITUDINAL": [
      {
        position: [-1.5, 2.213, -2]
      },
      {
        position: [0.5, 2.213, -2]
      },
    ],
    "SIDE-PURLIN": [
      {
        position: [-2.018, 1.821, -1.992],
        rotation: [0, 0, 0.971]
      },
      {
        position: [1.064, 1.821, 1.993],
        rotation: [-Math.PI, 0, -2.171]
      },
    ]
  },
  "4500": {
    "OVERHEAD_IRRIGATION": {
      position: [-1, 2.527, 1.899]
    },
    "END-NOCUT": {
      position: [-0.996, 1.348, 1.441]
    },
    "CROSS": {
      position: [-1, 2.576, -2]
    },
    "RIDGE-BAR": {
      position: [-0.999, 2.573, -1.984]
    },
    "STEEL-GABLE": {
      'BACK': {
        position: [-0.4, 2.55, 2.002]
      }
    },
    "LONGITUDINAL": [
      {
        position: [-2.5, 2.213, -2]
      },
      {
        position: [0.5, 2.213, -2]
      },
    ],
    "SIDE-PURLIN": [
      {
        position: [-3.01, 1.821, -1.992],
        rotation: [0, 0, 0.971]
      },
      {
        position: [1.029, 1.821, 1.993],
        rotation: [-Math.PI, 0, -2.171]
      },
    ]
  },
  "5500": {
    "OVERHEAD_IRRIGATION": {
      position: [-1.49, 2.766, 3.899]
    },
    "END-NOCUT": {
      position: [-1.49, 1.071, 4.031]
    },
    "RIDGE-BAR": {
      position: [-1.49, 2.809, -0.001]
    },
    "STEEL-GABLE": {
      'BACK': {
        position: [-0.74, 2.778, 4]
      }
    },
    "LONGITUDINAL": [
      {
        position: [-3.44, 2.114, -2]
      },
      {
        position: [0.46, 2.114, -2]
      },
    ],
    "SIDE-PURLIN": [
      {
        position: [-3.71, 2.187, -2.001],
        rotation: [0, 0, 0]
      },
      {
        position: [0.732, 2.187, -2.001],
        rotation: [0, 0, -1.225]
      },
    ]
  },
  "6000": {
    "OVERHEAD_IRRIGATION": {
      position: [-1.74, 2.846, 3.899]
    },
    "END-NOCUT": {
      position: [-1.755, 1.247, 3.173]
    },
    "RIDGE-BAR": {
      position: [-1.74, 2.888, -0.001]
    },
    "STEEL-GABLE": {
      'BACK': {
        position: [-0.99, 2.868, 4]
      }
    },
    "LONGITUDINAL": [
      {
        position: [-3.44, 2.114, -2]
      },
      {
        position: [0.46, 2.114, -2]
      },
    ],
    "SIDE-PURLIN": [
      {
        position: [-4.033, 2.187, -2.001],
        rotation: [0, 0, 0]
      },
      {
        position: [0.553, 2.187, -2.001],
        rotation: [0, 0, -1.225]
      },
    ]
  },
  "7000": {
    "OVERHEAD_IRRIGATION": {
      position: [-2.24, 2.787, 3.899]
    },
    "V-BAR": [
      {
        position: [-2.233, 3.012, -1.936],
        rotation: [-Math.PI / 2, 0, -1.579]
      },
      {
        position: [-2.233, 3.012, 3.953],
        rotation: [-Math.PI / 2, 0, 1.563]
      },
    ],
    "END-NOCUT": {
      position: [-2.157, 1.645, 3.264]
    },
    "RIDGE-BAR": {
      position: [-2.24, 3.439, -0.001]
    },
    "STEEL-GABLE": {
      'BACK': {
        position: [-1.49, 3.405, 4]
      }
    },
    "LONGITUDINAL": [
      {
        position: [-0.24, 2.841, -2]
      },
      {
        position: [-4.24, 2.841, -2]
      },
    ],
    "SIDE-PURLIN": [
      {
        position: [-5.092, 2.439, -2.001],
        rotation: [0, 0, 0.173]
      },
      {
        position: [0.611, 2.439, -2.001],
        rotation: [0, 0, -1.332]
      }
    ]
  },
  "8000": {
    "OVERHEAD_IRRIGATION": {
      position: [-2.74, 2.787, 3.899]
    },
    "V-BAR": [
      {
        position: [-2.733, 3.071, -1.936],
        rotation: [-Math.PI / 2, 0, -1.579]
      },
      {
        position: [-2.747, 3.071, 3.938],
        rotation: [-Math.PI / 2, 0, 1.563]
      },
    ],
    "END-NOCUT": {
      position: [-2.743, 1.393, 4.147]
    },
    "RIDGE-BAR": {
      position: [-2.74, 3.498, -0.001]
    },
    "STEEL-GABLE": {
      'BACK': {
        position: [-1.99, 3.475, 4]
      }
    },
    "LONGITUDINAL": [
      {
        position: [-0.24, 2.841, -2]                                                                         
      },
      {
        position: [-5.24, 2.841, -2]
      },
    ],
    "SIDE-PURLIN": [
      {
        position: [-6.049, 2.439, -2.001],
        rotation: [0, 0, 0.173]
      },
      {
        position: [0.572, 2.439, -2.001],
        rotation: [0, 0, -1.097]
      },
    ]
  },
  "9000": {
    "OVERHEAD_IRRIGATION": {
      position: [-3.24, 2.787, 3.899]
    },
    "V-BAR": [
      {
        position: [-3.233, 3.146, -1.936],
        rotation: [-Math.PI / 2, 0, -1.579]
      },
      {
        position: [-3.247, 3.146, 3.94],
        rotation: [-Math.PI / 2, 0, 1.563]
      },
    ],
    "END-NOCUT": {
      position: [-3.244, 1.432, 3.889]
    },
    "RIDGE-BAR": {
      position: [-3.24, 3.568, -0.001]
    },
    "STEEL-GABLE": {
      'BACK': {
        position: [-2.49, 3.57, 4]
      }
    },
    "LONGITUDINAL": [
      {
        position: [-0.24, 2.841, -2]
      },
      {
        position: [-6.24, 2.841, -2]
      },
    ],
    "SIDE-PURLIN": [
      {
        position: [-7.002, 2.439, -2.001],
        rotation: [0, 0, 0.173]
      },
      {
        position: [0.519, 2.439, -2.001],
        rotation: [0, 0, -1.128]
      },
    ]
  },
}